export const BASE_AFIP_URL = "https://serviciosweb.afip.gob.ar";
